import { FREE } from "./enums";

export function separateProductsAndServices(productAndServices = []) {
  const products = productAndServices.filter(item => item.listingType === 'products');
  const services = productAndServices.filter(item => item.listingType === 'services');

  return { products, services };
}

export const isArrayLength = arr => {
  // Check if the input parameter is an array and has a length greater than zero.
  return Array.isArray(arr) && (arr.length > 0 ?? false);
};

export const updateProductAndServices = (productAndServices = [], productAndServicesArr = []) => {
  return productAndServices.map(item => {
    const cleanedItem = Object.fromEntries(
      Object.entries(item).filter(([key, value]) => value !== '')
    );

    const matchingEntry = productAndServicesArr.find(
      entry => entry.uuid === cleanedItem.productId || entry.uuid === cleanedItem.serviceId
    );

    if (matchingEntry) {
      cleanedItem.title = matchingEntry.title;
    }

    return cleanedItem;
  });
};

export const cleanPublicData = updateValues => {
  const { publicData } = updateValues;

  // Create a new object by filtering out keys with null, undefined, or empty string values
  const cleanedPublicData = Object.fromEntries(
    Object.entries(publicData).filter(
      ([, value]) => value !== null && value !== undefined && value !== ''
    )
  );

  // Return a new `updateValues` object with the cleaned `publicData`
  return {
    ...updateValues,
    publicData: cleanedPublicData,
  };
};


export const getAddressObjectId = user => {
  return user?.attributes?.profile?.publicData?.addressObjectId;
};

function transformShippingDetails(address) {
  if (!address) return null;

  const { street1, street2, street3, phone, ...rest } = address;

  // Return the transformed object with line1, line2, and line3
  return {
    ...rest,
    line1: street1 || null,
    line2: street2 || null,
    line3: street3 || null,
    phoneNumber: phone,
  };
}

export const getShippingDetails = user => {
  const address = user?.id && user?.attributes?.profile?.protectedData?.shippoAddress;
  const transformedDetails = transformShippingDetails(address);

  return transformedDetails || null;
};

export const getUserFullName = user => {
  if (!user?.id) return null;

  const firstName = user?.attributes?.profile?.firstName;
  const lastName = user?.attributes?.profile?.lastName;
  return firstName && lastName ? `${firstName} ${lastName}` : null;
};

export const getDefaultDimensions = user => {
  return user?.attributes?.profile?.publicData?.defaultDimensions;
};
export const capitalizeFirstLetter = str => str && str[0].toUpperCase() + str.slice(1);

export const getPayInTotal = tx => {
  return tx && tx.id && tx?.attributes?.payinTotal?.amount;
};


export const getShippingPreference = currentUser => {
  return (
    currentUser &&
    currentUser.id &&
    currentUser?.attributes?.profile?.publicData?.shippingPreference
  );
};

export const getListingField = (config, fieldPath, keys) => {
  // Ensure `keys` is an array, if it's a string convert it to an array
  const keyList = Array.isArray(keys) ? keys : [keys];

  // Traverse to the required field path
  const field = fieldPath.split('.').reduce((obj, part) => obj && obj[part], config);
  if (!field || !Array.isArray(field)) {
    return null; // Return null if the field path doesn't exist or isn't an array
  }

  // Filter and map the results for the given keys
  const results = keyList.map(key => {
    const fieldItem = field.find(item => item.key === key);
    return fieldItem ? { key: fieldItem.key, enumOptions: fieldItem.enumOptions } : null;
  });

  // Return the results, removing any null entries
  return results.filter(result => result !== null);
};

export const getConfigOptions = (configEnumOptions, key, isPartialMatch = false) => {
  if (!configEnumOptions || !key) return [];

  return isPartialMatch
    ? configEnumOptions?.filter(eo => eo?.key.includes(key))?.flatMap(eo => eo?.enumOptions || [])
    : configEnumOptions.find(eo => eo?.key === key)?.enumOptions || [];
};

export const getTrackingDetails = tx => {
  const trackingInfo = tx && tx.id && tx?.attributes?.metadata?.trackingInfo;
  const carrierName = tx && tx.id && tx?.attributes?.protectedData?.rate?.servicelevel?.name;

  return {
    ...trackingInfo,
    carrierName,
    trackingNumber: trackingInfo?.trackingNumber || null,
    trackingUrlProvider: trackingInfo?.trackingUrlProvider || null,
    trackingLabel: trackingInfo?.labelUrl || null,
    rate: trackingInfo?.rate || null,
  };
};

export const getDestinationAddress = tx => {
  const trackingInfo = tx && tx.id && tx?.attributes?.metadata?.destinationAddress;
  return trackingInfo;
};

export const cardRenderSizes = isMapVariant => {
  if (isMapVariant) {
    // Panel width relative to the viewport
    const panelMediumWidth = 50;
    const panelLargeWidth = 62.5;
    return [
      '(max-width: 767px) 100vw',
      `(max-width: 1023px) ${panelMediumWidth}vw`,
      `(max-width: 1920px) ${panelLargeWidth / 2}vw`,
      `${panelLargeWidth / 3}vw`,
    ].join(', ');
  } else {
    // Panel width relative to the viewport
    const panelMediumWidth = 50;
    const panelLargeWidth = 62.5;
    return [
      '(max-width: 549px) 100vw',
      '(max-width: 767px) 50vw',
      `(max-width: 1439px) 26vw`,
      `(max-width: 1920px) 18vw`,
      `14vw`,
    ].join(', ');
  }
};

export const filterListingsByType = (listings, type) => {
  return listings.filter(listing => listing?.attributes?.publicData?.listingType === type);
};